/*
  This example requires Tailwind CSS v2.0+ 
  
  This example requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/aspect-ratio'),
    ],
  }
  ```
*/

import React from "react"
import Training from "../images/Training.jpeg"
import Seminar from "../images/Seminar.jpeg"
import csr from "../images/csr.png"

const people = [
  {
    name: "Training",
    role: "Senior Front-end Developer",
    imageUrl: Training,
    bio: "Live virtual or face-to-face capacity-building training through all modules of the Learning Curriculum and how to use them in your community.",
  },
  {
    name: "Seminar",
    role: "Senior Front-end Developer",
    imageUrl: Seminar,
    bio: "Access to WASH training events, seminars, news on innovative teaching and learning tools, and other opportunities.",
  },
  {
    name: "CSR",
    role: "Senior Front-end Developer",
    imageUrl: csr,
    bio: "Opportunities to elevate the Corporate Social Responsibility (CSR) portfolios of businesses through sponsorship of handwashing stations and other resources for integrated learning.",
  },
  // More people...
]

export default function Help() {
  return (
    <div className="bg-white">
      <div className="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-16">
        <div className="space-y-12 lg:grid lg:grid-cols-3 lg:gap-8 lg:space-y-0">
          <div className="space-y-5 sm:space-y-4">
            <h2 className="pb-10 text-xl font-extrabold tracking-tight sm:text-4xl">
              How We Help You
            </h2>
            <h3 className="pb-10 text-5xl">
              A Passion for Improving the Learning Experience
            </h3>
            <p className="text-xl text-gray-500">
              WASHEd gives you the flexibility and competency to deliver
              impactful lessons for the community.
            </p>
          </div>
          <div className="lg:col-span-2">
            <ul
              role="list"
              className="space-y-12 sm:grid sm:grid-cols-3 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:gap-x-8"
            >
              {people.map(person => (
                <li key={person.name}>
                  <div className="space-y-4">
                    <div className="aspect-w-3 aspect-h-2">
                      <img
                        className="object-cover shadow-lg rounded-lg"
                        src={person.imageUrl}
                        alt=""
                      />
                    </div>
                    <div className="text-lg leading-6 font-medium space-y-1">
                      {/* <h3>{person.name}</h3> */}
                      {/* <p className="text-indigo-600">{person.role}</p> */}
                    </div>
                    <div className="text-lg">
                      <p className="text-gray-500">{person.bio}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
